module.exports = __webpack_public_path__ + "static/media/icon_new_right_carousel.71e25b95.svg";